/**
 * Proposed Disposition choices (`proposed_rejection_type`), one list for the
 * NCR create form and the NCR page.
 */
export interface DispositionOption {
  value: number;
  label: string;
}

const DISPOSITION_OPTIONS: DispositionOption[] = [
  { value: 0, label: 'Please Select' },
  { value: 1, label: 'Return to Supplier' },
  { value: 2, label: 'Scrap' },
  { value: 3, label: 'Rework' },
  { value: 4, label: 'Use As Is' },
  { value: 5, label: 'Sort' },
];
const RETURN_TO_SUPPLIER = 1;

/**
 * The choices to offer. E29: an internal NCR is never sent to the supplier, so
 * "Return to Supplier" is left out unless it is the NCR's saved choice.
 *
 * @param isInternal - the NCR is handled internally
 * @param current - the saved disposition, if any
 * @returns the options in display order
 */
export function dispositionOptionsFor(isInternal: boolean, current: number | null | undefined): DispositionOption[] {
  if (!isInternal || current === RETURN_TO_SUPPLIER) return DISPOSITION_OPTIONS;
  return DISPOSITION_OPTIONS.filter((o) => o.value !== RETURN_TO_SUPPLIER);
}
